<template>
  <v-card>
    <v-container fluid class="pa-0">
      <v-flex xs12>
        <v-text-field label="Search Widget" v-model="search" single-line full-width hide-details></v-text-field>
      </v-flex>
      <v-flex xs12>
        <v-divider></v-divider>
      </v-flex>
    </v-container>
    <v-card-text>
      <template v-if="totalWidgets > 0">
        <v-checkbox
          v-for="widget in filteredWidgets"
          :key="widget.value"
          :label="widget.label"
          :value="widget.value"
          v-model="selectedWidgets"
        ></v-checkbox>
      </template>
      <template v-else> No widget found </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { widgets } from './index'
export default {
  data() {
    return {
      search: '',
      widgetsArr: [],
      selectedWidgets: []
    }
  },
  watch: {
    selectedWidgets: function (value, oldValue) {
      // Need find out what is added / removed
      if (value.length > oldValue.length) {
        // Added
        let diff = value.filter((x) => !oldValue.find((a) => x === a))
        if (diff && diff.length > 0) {
          this.$store.dispatch('addWidget', diff[0])
        }
      } else if (value.length < oldValue.length) {
        // Removed
        let diff = oldValue.filter((x) => !value.find((a) => x === a))
        if (diff && diff.length > 0) {
          this.$store.dispatch('removeWidget', diff[0])
        }
      }
    },
    initStatus: function (value) {
      if (value === 1) {
        this.doInit()
      }
    }
  },
  computed: {
    initStatus() {
      return this.$store.state.widgets.init
    },
    globalWidgets() {
      return this.$store.state.widgets.widgets
    },
    filteredWidgets() {
      if (this.search && this.search !== '') {
        const result = this.widgetsArr.filter((widget) => {
          return widget.label.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
        })
        return result
      } else {
        return this.widgetsArr
      }
    },
    totalWidgets() {
      if (this.filteredWidgets) {
        return this.filteredWidgets.length
      } else {
        return 0
      }
    }
  },
  methods: {
    doInit() {
      this.convertWidgetState()
      this.getPermitWidgets()
    },
    convertWidgetState() {
      // Convert vuex widget state to dashboard local state
      this.selectedWidgets = []
      if (this.globalWidgets && this.globalWidgets.length > 0) {
        this.globalWidgets.map((widget) => {
          this.selectedWidgets.push(widget.i)
        })
      }
    },
    getPermitWidgets() {
      if (widgets) {
        // Convert widgets object format to array for display
        let newWidgetsArr = []
        const globalPermitWidgets = this.$store.state.widgets.permitWidgets
        Object.keys(widgets).forEach(function (key) {
          // Check if it is permitted
          if (key in globalPermitWidgets) {
            const widget = {
              label: widgets[key].name,
              value: key
            }
            newWidgetsArr.push(widget)
          }
        })
        this.widgetsArr = newWidgetsArr
      }
    }
  },
  mounted() {
    if (this.initStatus === 1) {
      this.doInit()
    } else {
      // Might (just in case) have chance that dashboard has not inited when you open up this menu
      // use watch to settle this
    }
  }
}
</script>

<style lang="scss">
</style>
